<template>
  <div id="app">
    <div v-if="!loginStatus">
      <login @login-success="setUser"></login>
    </div>
    <div v-else class="main-container home-container">
      <HomePage></HomePage>
    </div>
  </div>
</template>

<script>
import Login from "@/components/Login.vue";
import HomePage from "@/components/home/index.vue"
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: "App",
  components: {
    Login,
    HomePage,
  },
  data() {
    return {
      user: {},
      // base_url: 'https://crr11.cn/api'
    };
  },
  computed: {
    ...mapGetters(['loginStatus']),
  },
  methods: {
    ...mapActions({
      getSetting: 'getSetting',
    }),
    ...mapMutations([
      'setLoginStatus',
      'setState'
    ]),
    initData () {
      this.getSetting({
        settingGroup: 'common'
      }).then(res => {
        if (res.paCode === '000') {
          this.setState({
            stateName: 'commonConfig',
            value: res.paData
          })
        }
      })
    },
    checkLoginStatus() {
      const loggedIn = localStorage.getItem("loggedIn");
      const user = JSON.parse(localStorage.getItem("user"));
      console.log('loggedIn:', loggedIn)
      this.setLoginStatus(!!loggedIn)
      // this.loggedIn = loggedIn === "true";
      this.user = user;
    },
    setUser(user) {
      this.setLoginStatus(true);
      this.user = user;
    },
  },
  created() {
    this.initData()
    this.checkLoginStatus();
  },
};
</script>

<style scoped>
#app {
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.home-container {
  display: flex;
  height: 100%;
  width: 100%;
  background-color: #f8f9fb;
}
</style>
<style src="@/assets/styles/main.css"></style>
<style src="@/assets/styles/base.css"></style>
